import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import EmulatedStreamingText from "app/pages/sales-intelligence/common-components/EmulatedStreamingText/EmulatedStreamingText";
import type { IScoringRuleBusinessContextDto } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import LeadScoreSummaryWrapper from "../LeadScoreSummaryWrapper/LeadScoreSummaryWrapper";

interface IProps {
    isAnimateSummary: boolean;
    summary: string;
    businessContexts?: readonly IScoringRuleBusinessContextDto[];
}

const LeadScoreSummaryContent = ({ isAnimateSummary, summary, businessContexts }: IProps): ReactElement => {
    return (
        <Flex
            gap="16px"
            flexDirection="column"
        >
            {(businessContexts || [])
                .map((businessContext: IScoringRuleBusinessContextDto, index: number) =>
                    businessContext.actionItem ? (
                        <Text
                            key={index}
                            fontVariant="primaryItem"
                            lineHeight="20px"
                            color={colorsPalettes.carbon["400"]}
                        >
                            {businessContext.actionItem}
                        </Text>
                    ) : null,
                )
                .filter(Boolean)}

            <LeadScoreSummaryWrapper>
                <EmulatedStreamingText
                    fontVariant="primaryItem"
                    color={colorsPalettes.carbon["400"]}
                    lineHeight="20px"
                    isAnimate={isAnimateSummary}
                >
                    {summary}
                </EmulatedStreamingText>
            </LeadScoreSummaryWrapper>
        </Flex>
    );
};

export default LeadScoreSummaryContent;
